import { UIText1, Button, ModalWindow, Image } from '@cian/ui-kit';
import * as React from 'react';

import { ChatbotMenuPinFilter } from './ChatbotMenuPinFilter/ChatbotMenuPinFilter';
import * as styles from './ChatbotMobileMenu.css';
import { IChatbotActionButtonSchema } from '../../types/chatbot';

type TProps = {
  isOpen: boolean;
  toggleMenu: () => void;
  actionButtons: IChatbotActionButtonSchema[];
  onItemClick(actionButtonChatbot: IChatbotActionButtonSchema): void;
  disabled: boolean;
  menuText: string;
};

export const ChatbotMobileMenu: React.FC<TProps> = ({
  isOpen,
  toggleMenu,
  actionButtons,
  onItemClick,
  disabled,
  menuText,
}) => {
  const handleClick = React.useCallback(
    (e: React.SyntheticEvent<HTMLLIElement>) => onItemClick(actionButtons[Number(e.currentTarget.dataset.index)]),
    [actionButtons, onItemClick],
  );

  return (
    <>
      <span className={styles['button']}>
        <Button disabled={disabled} theme="fill_primary" onClick={toggleMenu} data-name="ChatbotMenu_button">
          Меню
        </Button>
      </span>
      <ModalWindow open={isOpen} onClose={toggleMenu} title="Меню" fixed>
        <ChatbotMenuPinFilter menuText={menuText} />
        <ul className={styles['container']} data-name="ChatbotMenu_list">
          {actionButtons.map(({ text, leftIcon }, index) => (
            <li
              key={`chatbot-mobile-menu-item-${index}`}
              className={styles['item']}
              onClick={handleClick}
              data-index={index}
            >
              {leftIcon && (
                <div className={styles['image']}>
                  <Image src={leftIcon} width={16} height={16} preloader={false} borderRadius="0" />
                </div>
              )}
              <UIText1 fontWeight="600">{text}</UIText1>
            </li>
          ))}
        </ul>
      </ModalWindow>
    </>
  );
};
